import { useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import FeaturesSection from './sections/FeaturesSection';
import AboutSection from './sections/AboutSection';
import ProgramsSection from './sections/ProgramsSection';
import CombinedSection from './sections/CombinedSection';
import ContactSection from './sections/ContactSection';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <HeroSection />
      <FeaturesSection />
      <AboutSection />
      <ProgramsSection />
      <CombinedSection />
      <ContactSection />
    </motion.div>
  );
};

export default HomePage;